<template>
  <v-dialog v-model="dialogEditShow" max-width="1424px" persistent>
    <v-card class="pa-4 pa-sm-8 test-editor" v-if="domain">
      <h4 class="mb-5">Интервалы шкал для домена "{{ domain.title }}"</h4>
      <v-btn class="button-close ma-4" icon @click="dialogEditShow=false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div class="items-list-wrapper">
        <transition-group class="items-list w-100" name="list-complete" tag="div">
          <div v-if="!intervals || !intervals.length" class="mb-4" :key="-1">Добавьте интервалы</div>
          <div class="row row-complete-item item-question" v-for="interval in intervals" :key="interval.idTmp">
            <div class="col-12 _col-sm-1 d-flex align-center pb-0 pt-6">
              <div class="d-flex flex-wrap align-center">
                <div class="_mt-13 mr-4 mb-1">Интервал:</div>
                <v-text-field label="От" dense class="rank mt-2 mr-4" v-model="interval.value_from" style="width:50px"
                  :error="errorIntervals.includes(interval.idTmp)"
                />
                <v-text-field label="До" _outlined dense class="mt-2" v-model="interval.value_to" style="width:50px"
                  :error="errorIntervals.includes(interval.idTmp)"
                />
                <div class="ml-13 mr-4 mb-1">Цвет:</div>
                <ColorPickerButton v-model="interval.color" class="pb-3" />
                <!-- <div class="ml-13 mr-4 mt-1"></div> -->
                <v-text-field label="Краткое название для диаграммы" dense class="ml-13 mt-2" v-model="interval.subtitle" style="width:360px" />
              </div>
            </div>
            <div class="col-12 _col-sm-11 d-flex align-center pt-0 pb-8">
              <html-content-editor v-model="interval.description" :update="forceUpdate" @_input="changed()" title="Описание:" class="w-100 mr-1"/>
              <html-content-editor v-model="interval.candidate_recommendation" :update="forceUpdate" @_input="changed()" title="Рекомендации кандидата:" class="w-100 mr-1"/>
              <html-content-editor v-model="interval.manager_recommendation" :update="forceUpdate" @_input="changed()" title="Рекомендации менеджера:" class="w-100"/>
              <v-btn icon color="error" @click="askDelete(interval)"><v-icon>mdi-delete-outline</v-icon></v-btn>
            </div>
          </div>
          <div class="row row-complete-item" :key="-2">
            <v-btn class="add-button" fab dark small color="primary" @click="addItem()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </transition-group>
      </div>

      <div class="error-message" :class="{ shake: showShake }">{{ errorMessage }}</div>
      <div class="row mt-4 justify-end">
        <v-btn class="mr-3 _w-100" @click="dialogEditShow=false"> Закрыть </v-btn>
        <v-btn class="mr-3 _w-100" color="primary" @click="okClicked" :loading="saving"> Сохранить </v-btn>
      </div>
    </v-card>
    <AskDialog v-model="showAskDeleteDialog" @ok="delItem(curInterval)" />
  </v-dialog>
</template>

<script>
/*eslint-disable*/
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import AskDialog from '@/components/ui/AskDialog';
import HtmlContentEditor from '@/components/testEditor/htmlEditor/HtmlContentEditor.vue';
import ColorPickerButton from '@/components/ui/ColorPickerButton.vue';

export default {
  name: 'EditIntervalsDialog',
  components: {
    AskDialog, HtmlContentEditor, ColorPickerButton
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: Boolean,
    domain: Object,
  },
  data: () => ({
    intervals: [],
    showAskDeleteDialog: false,
    curInterval: null,
    errorIntervals: [],
    errorMessage: '',
    showShake: false,
    saving: false,
    forceUpdate: false,
  }),
  watch: {
    async dialogEditShow(newVal) {
      console.log("Load intervals for domain ", newVal, this.domain)
      if (newVal) {
        this.clearError()
        this.intervals = []
        await this.loadIntervals()
        this.intervals = cloneDeep(this.srcIntervals)
        this.intervals = this.intervals.map(el => ({...el, idTmp: el.id}))
        this.intervals.sort((a, b) => a.value_from - b.value_from)
        this.forceUpdate = !this.forceUpdate
      } else {
        this.intervals = []
      }
    }
  },
  computed: {
    dialogEditShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', false);
      }
    },
    ...mapGetters({
      loading: 'testEditor/domains/loading',
      allIntervals: 'testEditor/domains/intervals',
    }),
    srcIntervals() {
      return this.allIntervals.filter(el => el.domain === this.domain.id)
    }
  },

  methods: {
    ...mapActions({
      saveInterval: 'testEditor/domains/saveInterval',
      addInterval: 'testEditor/domains/addInterval',
      delInterval: 'testEditor/domains/delInterval',
      loadIntervals: 'testEditor/domains/loadIntervals',
    }),
    clearError() {
      this.errorIntervals = []
      this.errorMessage = ''
    },
    setRange(interval, arr) {
      interval.value_from = arr[0]
      interval.value_to = arr[1]
      this.clearError()
    },
    addItem() {
      this.clearError()
      this.intervals.push({
        value_from: 0,
        value_to: 0,
        description: "Описание",
        manager_recommendation: "",
        candidate_recommendation: "",
        domain: this.domain.id,
        subtitle: '',
        color: '#E53E3E',
        idTmp: (new Date()).getTime()
      })
    },
    askDelete(interval) {
      this.curInterval = interval
      this.showAskDeleteDialog = true
    },

    delItem(interval) {
      this.clearError()
      const ind = this.intervals.findIndex(el => el.idTmp === interval.idTmp)
      if (ind>=0)
        this.intervals.splice(ind, 1);
    },
    checkIntervals () {
      this.intervals.forEach(el => {
        el.value_from = +el.value_from
        el.value_to = +el.value_to
      });
      const maxValue = Math.max(...this.intervals.map(el => el.value_to));
      this.intervals.sort((a, b) => a.value_from - b.value_from);


      for (let i = 1; i < this.intervals.length; i++) {
        if (this.intervals[i].value_from === this.intervals[i].value_to) {
          this.errorIntervals.push(this.intervals[i].idTmp)
          return "Не должно быть пустых интервалов";
        }
        if (this.intervals[i].value_from !== this.intervals[i - 1].value_to) {
          this.errorIntervals.push(this.intervals[i - 1].idTmp)
          this.errorIntervals.push(this.intervals[i].idTmp)
          return "Интервалы пересекаются или содержат пропуск";
        }
      }

      return true;
    },

    async okClicked() {
      this.clearError()
      const check = this.checkIntervals ()
      if (check !== true) {
        this.errorMessage = check
        this.showShake = true;
        setTimeout(() => {
            this.showShake = false;
        }, 1000)
        return;
      }

      function copyInterval(dest, src) {
        dest.value_from = isNaN(+src.value_from) ? 0 : +src.value_from
        dest.value_to = isNaN(+src.value_to) ? 0 : +src.value_to
        dest.description = src.description
        dest.candidate_recommendation = src.candidate_recommendation
        dest.manager_recommendation = src.manager_recommendation
        dest.subtitle = src.subtitle
        dest.color = src.color
        dest.domain = src.domain
        return dest
      }

      this.saving = true
      let i = 0
      let countSrc = this.srcIntervals.length
      for (; i<this.intervals.length ; i++) {
        if (i<countSrc) {
            await this.saveInterval(copyInterval(this.srcIntervals[i], this.intervals[i]))
        } else {
            await this.addInterval(this.intervals[i])
        }
      }

      const toDel = []
      for ( ; i<countSrc ; i++)
        toDel.push(this.srcIntervals[i])

      for (let interval of toDel) {
          await this.delInterval(interval)
      }

      this.saving = false
      this.dialogEditShow = false
    },
  }
};
</script>

<style scoped>
.error-message {
  color: red;
  height: 16px;
}

.shake {
    animation-name: wobble;
    animation-duration:          0.8s;
    animation-iteration-count:   1;
    animation-timing-function:   linear;
    transform-origin:            50% 100%;
}

@keyframes wobble {
  0% { transform: none; }
  15% { transform: translateX(-4%); }
  30% { transform: translateX(3%) ;  }
  45% { transform: translateX(-2%) ;  }
  60% { transform: translateX(1%) ;  }
  75% { transform: translateX(-0.5%) ;  }
  100% { transform: none; }
}


</style>
